import { NgxLoggerLevel } from 'ngx-logger';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  name: 'Dev',
  production: false,
  logLevel: NgxLoggerLevel.TRACE,
  serverLogLevel: NgxLoggerLevel.OFF,
  // baseAPIUrl: 'http://localhost:3000',
  baseAPIUrl: 'https://healic-dev-api.4thpointer.in',
  version: '5450d41a17',
  apiCallingTime: 1000 * 120,
};
